var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Offline",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M41.71,43.48a1.69,1.69,0,0,1-1-.3,3.72,3.72,0,0,1-.49-.42L32,34.5l-8.25,8.25a2,2,0,0,1-1.45.72,1.87,1.87,0,0,1-.37,0,1.75,1.75,0,0,1-1-2.86c.09-.1.18-.2.28-.29L29.5,32l-8.25-8.25a1.88,1.88,0,0,1-.68-1.82,1.75,1.75,0,0,1,1.73-1.42,1.72,1.72,0,0,1,1.13.42l.3.29L32,29.5l8.34-8.34a1.87,1.87,0,0,1,1.34-.63,2,2,0,0,1,.45.05,1.73,1.73,0,0,1,1.22,1.07,1.7,1.7,0,0,1-.18,1.61,3.57,3.57,0,0,1-.42.49L34.5,32l8.34,8.34a1.8,1.8,0,0,1,.58,1.79A1.76,1.76,0,0,1,41.71,43.48Z"/>
    <path d="M22.29,21a1.22,1.22,0,0,1,.81.3l.26.25.07.07,5.78,5.78,2.09,2.09.71.71.71-.71,1.68-1.68,6.3-6.31a1.34,1.34,0,0,1,1-.48,1.52,1.52,0,0,1,.33,0,1.24,1.24,0,0,1,.74,1.9,3.18,3.18,0,0,1-.37.43L34.5,31.3l-.71.71.71.71,1.57,1.57,6.42,6.42A1.29,1.29,0,0,1,42.93,42a1.25,1.25,0,0,1-1.22,1,1.17,1.17,0,0,1-.68-.21,3.18,3.18,0,0,1-.43-.37L32.7,34.5,32,33.79l-.71.71-1.8,1.8L23.4,42.4a1.5,1.5,0,0,1-1.1.57l-.27,0a1.25,1.25,0,0,1-.71-2l.24-.25.07-.07,7.66-7.66.21-.21.71-.71-.71-.71-1.81-1.81L21.6,23.4A1.39,1.39,0,0,1,21.06,22a1.25,1.25,0,0,1,1.24-1m0-1a2.25,2.25,0,0,0-2.22,1.82,2.4,2.4,0,0,0,.82,2.27L28.79,32l-7.87,7.87c-.12.12-.25.24-.36.38a2.25,2.25,0,0,0,1.28,3.68,2.39,2.39,0,0,0,.46,0,2.52,2.52,0,0,0,1.8-.87L32,35.21l7.9,7.9a4.18,4.18,0,0,0,.56.48,2.18,2.18,0,0,0,1.25.39,2.25,2.25,0,0,0,2.2-1.74A2.29,2.29,0,0,0,43.19,40l-8-8,7.89-7.9a4.18,4.18,0,0,0,.48-.56,2.24,2.24,0,0,0-1.34-3.45,2.5,2.5,0,0,0-.56-.06,2.35,2.35,0,0,0-1.7.78l-8,8-7.87-7.87c-.12-.12-.24-.25-.38-.36A2.22,2.22,0,0,0,22.29,20Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/offline.svg